import { ApiError, apiClient } from 'shared/api';
import { BaseResponseType } from 'shared/api';

export const patchPassword = async ({
  password,
  passwordConfirm,
  resetPasswordToken,
}: {
  password: string;
  passwordConfirm: string;
  resetPasswordToken: string;
}): Promise<BaseResponseType<string>> => {
  const { data } = await apiClient.patch('/auth/member/change-password', {
    password,
    passwordConfirm,
    resetPasswordToken,
  });

  // NOTE: 현재 실패한 요청에도 http code를 200으로 받고 있기 때문에 아래와 같이 처리합니다
  if (!data.isSuccess) {
    throw new ApiError(data);
  }

  return data;
};

export const postEmailCertification = async (email: string): Promise<BaseResponseType<string>> => {
  const { data } = await apiClient.post('/auth/member/email-certification', { email });

  // NOTE: 현재 실패한 요청에도 http code를 200으로 받고 있기 때문에 아래와 같이 처리합니다
  if (!data.isSuccess) {
    throw new ApiError(data);
  }

  return data;
};
